import React from 'react';
import { Box } from '@mui/material';

interface CategoryIconProps {
  categoryID: number;
  size?: number;
  color?: string;
}

const CategoryIcon: React.FC<CategoryIconProps> = ({ 
  categoryID, 
  size = 20, 
  color = '#000000' 
}) => {
  // Map category IDs to icon filenames
  const getIconFileName = (id: number): string => {
    const iconMap: { [key: number]: string } = {
      1: 'condo.svg',           // คอนโด
      3: 'house.svg',           // บ้านเดี่ยว
      2: 'townhouse.svg',       // ทาวน์เฮาส์-โฮม
      24: 'twin-house.svg',     // บ้านแฝด
      4: 'home-office.svg',     // โฮมออฟฟิศ
      5: 'land.svg',            // ที่ดิน
      9: 'commercial.svg',      // อาคารพาณิชย์-ตึกแถว
      7: 'apartment.svg',       // อพาร์ทเมนท์
      25: 'luxury-house.svg',   // บ้านหรู-คฤหาสน์
      10: 'space.svg',          // พื้นที่
      11: 'hotel.svg',          // โรงแรม
      17: 'resort.svg',         // รีสอร์ท
      16: 'factory.svg',        // โรงงาน
      8: 'warehouse.svg',       // โกดัง-คลังสินค้า
      6: 'office.svg',          // สำนักงาน
    };
    
    return iconMap[id] || 'condo.svg'; // Default fallback
  };

  const iconFileName = getIconFileName(categoryID);
  const iconPath = `/icons/categories/${iconFileName}`;

  return (
    <Box
      component="img"
      src={iconPath}
      alt={`Category ${categoryID} icon`}
      sx={{
        width: size,
        height: size,
        filter: color !== '#000000' ? `brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)` : 'none',
        display: 'block',
        objectFit: 'contain',
      }}
    />
  );
};

export default CategoryIcon; 